export default __webpack_public_path__ + "static/media/fries.3f04de68.svg";